<div class="container-fluid">
  <div class="d-flex flex-wrap justify-content-center  gap-3">
    @for (menu of menu; track $index) {
    @if (menu.childMenus != null && menu.childMenus.length>0) {
    <div class="accordion w-100 mb-3" [id]="'accordionItem'+menu.name">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#accordionItemOne'+menu.name" aria-expanded="false"
            [attr.aria-controls]="'#accordionItemOne'+menu.name">
            <i class="{{menu.icon}} card-icon me-5"></i>
            {{menu.description}}
          </button>
        </h2>
        <div [id]="'accordionItemOne'+menu.name" class="accordion-collapse collapse"
          [attr.data-bs-parent]="'#accordionItem'+menu.name">
          <div class="accordion-body d-flex justify-content-center flex-wrap gap-3">
            @for (sub_menu of menu.childMenus ; track $index) {
            <a (click)="openMenu(sub_menu)" class="link-card">
              <div class="card inner-card shadow-sm ">
                <div class="card-body">
                  <div class="d-flex flex-column justify-content-around align-items-center h-100 px-3">
                    <i class="{{sub_menu.icon}} card-icon text-secondary"></i>
                    <span class="text-secondary">{{sub_menu.description}}</span>
                  </div>
                </div>
              </div>
            </a>
            }
          </div>
        </div>
      </div>
    </div>
    }
    @else {
    <a (click)="openMenu(menu)" class="link-card">
      <div class="card inner-card shadow-sm ">
        <div class="card-body">
          <div class="d-flex flex-column justify-content-around align-items-center h-100 px-3">
            <i class="{{menu.icon}} card-icon text-secondary"></i>
            <span class="text-secondary">{{menu.description}}</span>
          </div>
        </div>
      </div>
    </a>
    }
    }

  </div>
</div>